import React from "react";
import ChildCard from "./ChildCard";
import { Plus, User } from "lucide-react";

const MyChildrenSection = ({
  childrenList = [],
  loading = false,
  batches = [],
  onAddChild,
  onEditChild,
  onRemoveChild,
  onBookDemo,
  onOpenWorkspace,
}) => {
  return (
    <div className="bg-white border border-slate-200/90 rounded-3xl p-5 sm:p-6 shadow-xs space-y-4 text-left">
      {/* Section Header Row inside Container Card */}
      <div className="flex items-center justify-between pb-1">
        <h3 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
          My Children
        </h3>

        <button
          type="button"
          onClick={onAddChild}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl border border-blue-600 hover:bg-blue-50 text-blue-600 font-bold text-xs sm:text-sm shadow-3xs transition cursor-pointer"
        >
          <Plus className="w-4 h-4" />
          <span>Add Child</span>
        </button>
      </div>

      {/* Loading Skeleton */}
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="bg-white border-2 border-indigo-100 rounded-2xl p-4 space-y-3.5 animate-pulse"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-slate-200 rounded-full" />
                <div className="space-y-1.5 flex-1">
                  <div className="w-32 h-3.5 bg-slate-200 rounded" />
                  <div className="w-24 h-2.5 bg-slate-200 rounded" />
                </div>
              </div>
              <div className="w-full h-8 bg-slate-100 rounded-xl" />
              <div className="flex gap-2.5">
                <div className="flex-1 h-8 bg-slate-200 rounded-xl" />
                <div className="flex-1 h-8 bg-slate-200 rounded-xl" />
              </div>
              <div className="w-full h-8 bg-slate-200 rounded-xl" />
            </div>
          ))}
        </div>
      ) : childrenList && childrenList.length > 0 ? (
        /* Children Cards Grid inside Container Card */
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
          {childrenList.map((student) => (
            <ChildCard
              key={student.id || student.uid}
              student={student}
              batches={batches}
              onEditChild={onEditChild}
              onRemoveChild={onRemoveChild}
              onBookDemo={onBookDemo}
              onOpenWorkspace={onOpenWorkspace}
            />
          ))}
        </div>
      ) : (
        /* Empty State */
        <div className="bg-slate-50/70 border-2 border-dashed border-slate-200 rounded-2xl p-6 text-center space-y-3">
          <div className="w-10 h-10 bg-indigo-50 text-indigo-500 rounded-xl flex items-center justify-center mx-auto">
            <User className="w-5 h-5" />
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-extrabold text-slate-800">
              No Children Added Yet
            </h4>
            <p className="text-xs text-slate-500 font-medium max-w-sm mx-auto">
              Add your child to enroll them in live AI &amp; Robotics classes, track their learning journey, and launch their personal code studio.
            </p>
          </div>
          <button
            type="button"
            onClick={onAddChild}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl bg-[#5468ff] hover:bg-[#4355f0] text-white font-bold text-xs shadow-sm transition cursor-pointer"
          >
            <Plus className="w-3.5 h-3.5" />
            <span>Add Your First Child</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default MyChildrenSection;
